export type Web3ChainProtocol = 'ERC20' | 'BEP20' | 'ETH_SEPOLIA' | 'BNB_TEST' | 'ETH_GOERLI' | 'POLYGON';

const web3Protocols: Web3ChainProtocol[] = ['ERC20', 'BEP20', 'POLYGON', 'ETH_SEPOLIA', 'BNB_TEST', 'ETH_GOERLI'];

export default web3Protocols;
